import { render, staticRenderFns } from "./PersonalRelease.vue?vue&type=template&id=775ec34c&scoped=true&"
import script from "./PersonalRelease.vue?vue&type=script&lang=ts&"
export * from "./PersonalRelease.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalRelease.vue?vue&type=style&index=0&id=775ec34c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775ec34c",
  null
  
)

export default component.exports